// @ts-strict-ignore
import {Component} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {AbstractModal} from "src/app/shared/components/modal/abstractModal";
import {SetChannelValueRequest} from "src/app/shared/jsonrpc/request/setChannelValueRequest";
import {ChannelAddress, CurrentData, EdgeConfig, Utils} from "src/app/shared/shared";

@Component({
  templateUrl: "./modal.html",
  standalone: false,
})
export class ModalComponent extends AbstractModal {

  public mode: string;
  public tariffState: string;

  public readonly CONVERT_MODE = Utils.CONVERT_PV_MODE(this.translate);
  public readonly CONVERT_TARIFF_STATE = Utils.CONVERT_PV_MODE_FOR_TARIFF(this.translate);

  private hasTimeOfUseTariff = false;

  protected btns = [
    {
      name: this.translate.instant("GENERAL.SELL_TO_GRID"),
      value: "SELL_TO_GRID",
      icon: {color: "success", name: "pulse-outline"}
    },
    {
      name: this.translate.instant("GENERAL.MAX_POWER"),
      value: "MAX_POWER",
      icon: {color: "success", name: "play-outline"}
    },
    {
      name: this.translate.instant("GENERAL.OFF"),
      value: "INVERTER_OFF",
      icon: {color: "danger", name: "power-outline"}
    }];

  public async applyChanges() {
    if (this.formGroup.dirty && this.edge != null) {
      this.service.startSpinner("spinner");
      const modeValue = this.formGroup.get("mode").value;

      this.edge.sendRequest(this.websocket, new SetChannelValueRequest({
        componentId: this.component.id,
        channelId: "Mode",
        value: modeValue,
      })).then(() => {
        this.service.toast(this.translate.instant("GENERAL.CHANGE_ACCEPTED"), "success");
        this.formGroup.markAsPristine();
      }).catch(reason => {
        this.service.toast(this.translate.instant("GENERAL.CHANGE_FAILED") + "\n" + reason.error?.message, "danger");
      }).finally(() => {
        this.service.stopSpinner("spinner");
      });
    }
  }


  protected override updateComponent(config: EdgeConfig) {

    if (!this.hasTimeOfUseTariff) {
      config.listActiveComponents([], this.translate).forEach(component => {
        component.components.forEach(com => {

          this.hasTimeOfUseTariff = (com.factoryId?.includes("TimeOfUseTariff") ?? false) && com.isEnabled;

          if (this.hasTimeOfUseTariff) {
            this.btns = [
              {
                name: this.translate.instant("GENERAL.TARIFF"),
                value: "TARIFF",
                icon: {color: "success", name: "stats-chart-outline"},
              },
              ...this.btns,
            ];
          }

        });
      });
    }
  }

  protected override getChannelAddresses(): ChannelAddress[] {
    return [
      new ChannelAddress(this.component.id, "Mode"),
      new ChannelAddress(this.component.id, "TariffState"),
    ];
  }

  protected override getFormGroup(): FormGroup {
    return this.formBuilder.group({
      mode: new FormControl(this.component.properties.mode),
    });
  }

  protected override onCurrentData(currentData: CurrentData) {
    this.mode = currentData.allComponents[this.component.id + "/Mode"];
    this.tariffState = currentData.allComponents[this.component.id + "/TariffState"];
  }


}
